import styled from '@emotion/styled';
import { Box, themeGet } from '@qwealth/qcore';

import { BANNER_THEME_COLORS, type BannerType } from './Banner.types';

export const BannerContainer = styled.div<{ type: BannerType }>`
  display: flex;
  align-items: center;
  padding: 16px 18px;
  border-radius: 8px;
  margin-bottom: 16px;
  gap: 12px;
  background-color: ${p => themeGet(BANNER_THEME_COLORS[p.type].bg)(p)};
`;

export const IconWrapper = styled.div<{ type: BannerType }>`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  font-size: 20px;
  color: ${p => themeGet(BANNER_THEME_COLORS[p.type].icon)(p)};
`;

export const TextContent = styled(Box)`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 6px;
  flex: 1;
  min-width: 0;
`;

export const BannerTitle = styled.span`
  font-weight: 600;
  font-size: 14px;
`;

export const BannerMessage = styled.span`
  font-size: 14px;
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  color: inherit;
  opacity: 0.7;
  flex-shrink: 0;

  &:hover {
    opacity: 1;
  }
`;
